module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/sheshines-19-june-2025.json
// module id = 1493
// module chunks = 200894169979921